<template>
  <a-modal
    :title="'审核保证金明细'"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :width="600"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-spin :spinning="loading">
      <a-descriptions bordered :column="2">
        <a-descriptions-item :label="'ID'">{{ record.id }}</a-descriptions-item>
        <a-descriptions-item :label="'店铺名称'">{{ record.shopName }}</a-descriptions-item>
        <a-descriptions-item :label="'用户名称'">{{ record.userName }}</a-descriptions-item>
        <a-descriptions-item :label="'金额'">{{ record.amount }}</a-descriptions-item>
        <a-descriptions-item :label="'最高日提现额度'">{{ record.dailyWithdrawLimit }}</a-descriptions-item>
        <a-descriptions-item :label="'创建时间'">{{ formatDate(record.createTime) }}</a-descriptions-item>
      </a-descriptions>

      <!-- 缴纳保证金显示支付凭证 -->
      <div v-if="record.recordType === 1">
        <a-divider orientation="left">{{ '支付凭证' }}</a-divider>
        <div style="margin-bottom: 16px;">
          <a v-for="(image, index) in payVoucherImages" :key="index" :href="image" target="_blank" style="margin-right: 10px;">
            <a-avatar :src="image" :size="80" shape="square" />
          </a>
        </div>
      </div>

      <!-- 退还保证金显示收款信息 -->
      <div v-if="record.recordType === 2">
        <a-divider orientation="left">{{ '收款信息' }}</a-divider>
        <a-descriptions bordered :column="1">
          <a-descriptions-item :label="'收款人姓名'">{{ record.payeeName || '-' }}</a-descriptions-item>
          <a-descriptions-item :label="'收款账号'">{{ record.payeeAccount || '-' }}</a-descriptions-item>
          <a-descriptions-item :label="'开户银行'">{{ record.payeeBank || '-' }}</a-descriptions-item>
        </a-descriptions>
      </div>

      <a-form-model
        ref="form"
        :model="form"
        :rules="rules"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item :label="'审核状态'" prop="auditStatus">
          <a-radio-group v-model="form.auditStatus">
            <a-radio :value="2">{{ '审核通过' }}</a-radio>
            <a-radio :value="3">{{ '审核拒绝' }}</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item :label="'审核备注'" prop="auditRemark">
          <a-textarea
            v-model="form.auditRemark"
            :placeholder="'请输入审核备注'"
            :rows="4"
            :maxLength="500"
          />
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import { getShopDepositRecord, auditShopDepositRecord } from '@/api/shop/shopDepositRecord'

export default {
  name: 'ShopDepositRecordAuditForm',
  data() {
    return {
      title: '',
      visible: false,
      confirmLoading: false,
      loading: false,
      record: {},
      form: {
        id: undefined,
        auditStatus: undefined,
        auditRemark: undefined
      },
      rules: {
        auditStatus: [
          { required: true, message: '请选择审核状态', trigger: 'change' }
        ],
        auditRemark: [
          // { required: true, message: '审核备注不能为空', trigger: 'blur' },
          { min: 1, max: 500, message: '审核备注长度在1-500个字符', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    payVoucherImages() {
      if (!this.record.payVoucherImages) return []
      try {
        return JSON.parse(this.record.payVoucherImages)
      } catch (e) {
        return []
      }
    }
  },
  methods: {
    /** 打开对话框 */
    open(row) {
      this.visible = true
      this.loading = true
      this.record = { ...row }
      this.form.id = row.id
      getShopDepositRecord(row.id).then(response => {
        this.record = response.data
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    /** 确定按钮 */
    handleOk() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.confirmLoading = true
          auditShopDepositRecord(this.form).then(() => {
            this.handleCancel()
            this.$emit('ok')
            this.$message.success('审核成功')
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    /** 取消按钮 */
    handleCancel() {
      this.visible = false
      this.reset()
    },
    /** 表单重置 */
    reset() {
      this.$refs.form.resetFields()
      this.form = {
        id: undefined,
        auditStatus: undefined,
        auditRemark: undefined
      }
      this.record = {}
    },
    formatDate(time) {
      if (!time) return '-'
      return this.parseTime(time, '{y}-{m}-{d} {h}:{i}:{s}')
    }
  }
}
</script>

<style scoped>
</style>
